import { useMutation } from '@tanstack/react-query';
import { JsonValue } from 'type-fest';

import { useRequest, type MutationFunction } from '@frontend/api';

import type { AgentConversation } from './types';

type ToolApproval = {
  status: 'approved' | 'rejected';
  toolUseIds: string[];
};

export type StreamConversationPayload = {
  message?: string;
  toolApproval?: ToolApproval;
};

const getUseStreamConversationKey = () => ['agents', 'conversation', 'stream'];

type StreamConversationQueryParams = {
  uuid: string;
};

export const useStreamConversation: MutationFunction<
  AgentConversation,
  StreamConversationPayload,
  [StreamConversationQueryParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (body: StreamConversationPayload) =>
      request<AgentConversation & JsonValue>(`/agents/stream/${params.uuid}/`, {
        init: {
          method: 'POST',
          body,
        },
      }),
    ...queryOptions,
    mutationKey: getUseStreamConversationKey(),
  });
};
